export var ONE_APP_VERSIONS = {
    IMAGE_UPLOAD: '2.762.0',
    LINKS: '2.2071.0',
    SHARE: '2.1895.0',
};
